import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import { ToastContainer } from 'react-toastify';
import {
  APP_LIST,
  GlobalStyles,
  PERMISSIONS,
  THEME_VARIANT,
  LAYOUT,
} from '@shared/constants';
import {
  AppSwitcher,
  BarLayout,
  PrivateRoute,
  TokenComponent,
  SidebarHeaderLayout,
  ProfileMenu,
  Rating,
} from '@shared/components';
import { isAuthorized } from '@utils';
import { AppContextConsumer, UserContext } from '@shared/contexts';
import { SharedService } from '@consumers/services';
import BrandLogo from '@assets/icons/brand-logo.svg';
// import DarkThemeIcon from '@assets/icons/dark-theme-icon.svg';
// import LightThemeIcon from '@assets/icons/light-theme-icon.svg';
// import BoxLayoutIcon from '@assets/icons/box-layout.svg';
// import SidebarLayoutIcon from '@assets/icons/sidebar-layout.svg';
// import ClientsIcon from '@assets/icons/bank-grey.svg';
// import ClientsActiveIcon from '@assets/icons/bank.svg';
import SipModule from './sip-viewer';
import useStyles from './style';

export default () => {
  const classes = useStyles();

  const { userData } = React.useContext(UserContext);
  GlobalStyles();
  return (
    <Router>
      <Switch>
        <Route path='/token' component={TokenComponent} />
        <AppContextConsumer>
          {({
            headerElements,
            selectedThemeVariant,
            setSelectedThemeVariant,
            setSelectedLayout,
            currentWorkspace,
            appRatingData,
            setAppRatingData,
            selectedLayout,
          }) => {
            const Layout =
              selectedLayout === LAYOUT.SIDEBAR_HEADER
                ? SidebarHeaderLayout
                : BarLayout;

            return (
              <Layout
                hideSideBar
                headerContent={
                  <>
                    <img
                      alt='Brand logo'
                      src={BrandLogo}
                      width={137}
                      className='ml-7 c-pointer'
                      onClick={() => window.location.reload()}
                    />
                    <div className='flex-1'>{headerElements}</div>
                    <div className='d-flex f-align-center'>
                      {/* <IconButton
                      className='mr-4 p-2'
                      onClick={async () => {
                        const newThemeType =
                          selectedThemeVariant === THEME_VARIANT.LIGHT ? THEME_VARIANT.DARK : THEME_VARIANT.LIGHT;
                        setSelectedThemeVariant(newThemeType);
                        const { error } = await SharedService.updateThemeType(
                          userData.rcuser_uid,
                          newThemeType
                        );
                      }}
                    >
                      <img
                        src={
                          selectedThemeVariant === THEME_VARIANT.LIGHT
                            ? DarkThemeIcon
                            : LightThemeIcon
                        }
                      />
                    </IconButton>
                    <IconButton
                      className='mr-4 p-2'
                      onClick={async () => {
                        const newLayout =
                          selectedLayout === LAYOUT.SIDEBAR_HEADER ? LAYOUT.BOX : LAYOUT.SIDEBAR_HEADER;
                        setSelectedLayout(newLayout);
                      }}
                    >
                      <img
                        src={
                          selectedLayout === LAYOUT.SIDEBAR_HEADER
                            ? BoxLayoutIcon
                            : SidebarLayoutIcon
                        }
                      />
                    </IconButton> */}
                      <AppSwitcher
                        className='mr-5'
                        currentApp={APP_LIST.BOILERPLATE}
                        disabled={true}
                      />
                      <ProfileMenu
                        getVersion={SharedService.getVersion}
                        hasSettings={isAuthorized(PERMISSIONS.MANAGE_SETTINGS)}
                        currentWorkspace={currentWorkspace}
                        handleRatingOpen={() =>
                          setAppRatingData({ isOpen: true })
                        }
                        onUserDataFetched={user => {
                          setAppRatingData({
                            isOpen: user?.show_rating_popup_on_request,
                            showOnPackageSubmit:
                              user?.show_rating_popup_on_package_submit,
                          });
                        }}
                      />
                    </div>
                  </>
                }
                classes={{
                  listItemText: classes.listItemText,
                  appBar: classes.appBar,
                }}
                // drawerList={sideBarHeaderList}
              >
                <ToastContainer
                  className={classes.toastContainer}
                  bodyClassName='align-center'
                  // toastClassName={classes.toast}
                />
                {/* {userData?.role !== 'Customer' && (
                  <Rating
                    isOpen={appRatingData.isOpen}
                    isOpenedFromPackage={appRatingData.isOpenedFromPackage}
                    onClose={() => setAppRatingData({ isOpen: false })}
                  />
                )} */}
                <Switch>
                  <PrivateRoute path='/sip-viewer' component={SipModule} />
                  <Redirect from='/' exact to='/sip-viewer' />
                  <Route
                    render={props => (
                      <>
                        <div className='m-10 pt-10 d-flex f-justify-center f-align-center flex-1'>
                          <div>
                            <h2>Uh Oh! Something is not right...</h2>
                            <h4>
                              The page you are trying to access does not exist.
                            </h4>
                            <h4>
                              Maybe you want to go to{' '}
                              <span
                                className='color-primary c-pointer'
                                onClick={() => {
                                  props.history.push('/');
                                }}
                              >
                                Home
                              </span>{' '}
                              page?
                            </h4>
                          </div>
                        </div>
                      </>
                    )}
                  />
                </Switch>
              </Layout>
            );
          }}
        </AppContextConsumer>
      </Switch>
    </Router>
  );
};
